<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <section style="margin-bottom: 1%" v-if="$store.getters.hasFunction('payable_create')">
        <a-button type="primary" @click="createHandle">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t('新增预付单') }}
        </a-button>
      </section>
      <div class="form-content">
        <a-row :gutter="16" style="margin-top: 15px">
          <a-col :span="6">
            <CommonSelect
              :isBu="true"
              :list="$store.state.settlementBuList"
              :placeholder="$t('结算组织')"
              :code.sync="formData.businessUnitCode"
              @change="searchHandle(1)"
            />
          </a-col>
          <a-col :span="6">
            <a-input
              allow-clear
              v-model.trim="formData.orderSn"
              :placeholder="$t('请输入预付单号')"
            />
          </a-col>
          <!-- <a-col :span="6">
          <DateRangePicker
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseBizDate"
            :placeholder="$t(`业务日期`)"
            :start-time="formData.bizDateStart"
            :end-time="formData.bizDateEnd"
          />
        </a-col> -->
          <a-col :span="6">
            <CommonQuerySelect
              api="queryPurchaseSupplierList"
              :params="{
                status: 1,
              }"
              :placeholder="$t(`供应商`)"
              :code.sync="formData.payeeCode"
              :name.sync="formData.payeeName"
              valueName="supplier_code"
              labelName="supplier_name"
            />
          </a-col>
          <a-col :span="6">
            <SelectDocumentType :docType="docType" :code.sync="formData.orderType" />
          </a-col>
        </a-row>
        <a-row :gutter="16" style="margin-top: 15px">
          <a-col :span="6">
            <a-select
              v-model="formData.needGenerateVoucher"
              allow-clear
              :placeholder="$t('能否生成凭证')"
              style="width: 100%"
            >
              <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
              <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6">
            <a-select
              v-model="formData.voucherGenerated"
              allow-clear
              :placeholder="$t('已生成凭证')"
              style="width: 100%"
            >
              <a-select-option :value="1">{{ $t('是') }}</a-select-option>
              <a-select-option :value="0">{{ $t('否') }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row :gutter="16" class="mt10">
          <a-col :span="6">
            <a-button @click="searchHandle(1)" type="primary">
              <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
              {{ $t(`查询`) }}
            </a-button>
            <a-button @click="reset">
              <a-icon type="redo" />
              {{ $t(`重置`) }}
            </a-button>
          </a-col>
        </a-row>
      </div>

      <CommonTable
        class="mt10"
        ref="CommonTableRef"
        :statusList="deposit_payment_status"
        :showSelect="true"
        :selectedRowKeys.sync="selectedRowKeys"
        :selectedRows.sync="selectedRows"
        :scroll="{ x: 1500, y: scrollHeight }"
        :loading="tableLoading"
        :columns.sync="tableColumns"
        :data-source="tableData"
        :total="total"
        rowKey="id"
        @select="onSelectChange"
        @search="queryOrderList"
      >
        <template v-slot:header>
          <div class="flex-ct">
            <OperateBtn
              api="operateDoc"
              :text="$t('审核')"
              :params="{
                action: 'check',
                docType: docType,
                idList: selectedRowKeys,
              }"
              :disabled="selectedRows.length === 0"
              @success="handleCheckSuccess"
            />
            <PushBtn
              class="ml10"
              :docType="docType"
              :selectedRows="selectedRows"
              :disabled="selectedRows.length === 0"
            />
            <VoucherBtn
              class="ml10"
              :docType="docType"
              :selectedRows="selectedRows"
              :disabled="selectedRows.length === 0"
              @close="searchHandle"
            />
          </div>
        </template>
        <!-- 预付单号 -->
        <template v-slot:orderSn="{ text, record }">
          <span>
            <a @click="viewDetail(record)">{{ text }}</a>
            <a-icon
              type="copy"
              class="ml6"
              style="cursor: pointer; color: #1890ff"
              @click.stop="copyOrderSn(text)"
            />
          </span>
        </template>
        <template v-slot:sourceOrderCode="{ record }">
          <a>{{ record.sourceOrderCode }}</a>
        </template>
        <!-- 业务单号 -->
        <template v-slot:otherSns="{ record }">
          <div>
            {{ $t('业务单号') }}:
            <span class="text-link">{{ record.bizOrderSn }}</span>
          </div>
          <div>
            {{ $t('预到货通知单号') }}:
            <span class="text-link">{{ record.asnOrderSn }}</span>
          </div>
          <div>
            {{ $t('入库单号') }}:
            <span class="text-link">{{ record.receivedOrderSn }}</span>
          </div>
        </template>
        <!-- 金额（未含税） -->
        <template v-slot:amountWithoutTax="{ text, record }">
          <PriceInput :value="text" :showTxt="true" :currency="record.settlement_currency" />
        </template>
        <!-- 税额 -->
        <template v-slot:taxAmount="{ text, record }">
          <PriceInput :value="text" :showTxt="true" :currency="record.settlement_currency" />
        </template>
        <!-- 价税合计 -->
        <template v-slot:payableAmount="{ text, record }">
          <PriceInput :value="text" :showTxt="true" :currency="record.settlement_currency" />
        </template>
        <!-- 开票金额 -->
        <template v-slot:invoicedAmount="{ text, record }">
          <span v-if="text">
            <PriceInput :value="text" :showTxt="true" :currency="record.settlement_currency" />
          </span>
        </template>
      </CommonTable>
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import CommonTable from '@component/commonTable'
import PriceInput from '@component/priceInput'
import PushBtn from '@component/pushBtn'
import VoucherBtn from '@component/voucherBtn'
import SelectDocumentType from '@component/selectDocumentType'
import { convertKeysToCamelCase, spaceToComma, copy, fetchDocumentMappings } from '@/common'
import { subtract } from '@/common/number'
export default {
  name: 'depositPaymentList',
  activated() {
    this.searchHandle()
    this.fetchMappings()
  },
  components: {
    CommonTable,
    PriceInput,
    PushBtn,
    VoucherBtn,
    SelectDocumentType,
  },
  data() {
    return {
      docType: 'DepositPayment',
      formData: {
        orderSn: undefined,
        referenceNo: undefined,
        bizDateStart: undefined,
        bizDateEnd: undefined,
        status: '',
        payeeCode: undefined,
        needGenerateVoucher: undefined,
        voucherGenerated: undefined,
      },
      tableLoading: false,
      total: 0,
      selectedRowKeys: [],
      selectedRows: [],
      tableData: [],
      visible: false,
      waitInvoiceList: [],
      nextVisible: false,
      pendingSelectedIds: [], // 保存待重新选中的订单ID
      mappings: {
        orderType: {},
        sourceOrderType: {},
      },
    }
  },
  computed: {
    ...mapState(['deposit_payment_status', 'deposit_payment_type']),
    ...mapGetters([
      'depositPaymentTypeMapping',
      'depositPaymentStatusMapping',
      'sourceOrderTypeMapping',
    ]),
    scrollHeight() {
      return window.innerHeight - 470
    },
    tableColumns() {
      return [
        {
          dataIndex: 'orderSn',
          title: this.$t('预付单号'),
          key: 'orderSn',
          width: 200,
          scopedSlots: { customRender: 'orderSn' },
        },
        {
          title: this.$t('预付单状态'),
          width: 150,
          dataIndex: 'status',
          customRender: (text) => this.depositPaymentStatusMapping[text],
        },
        {
          title: this.$t('预付单类型'),
          width: 150,
          dataIndex: 'orderType',
          customRender: (text) => this.mappings.orderType[text] || text,
        },
        {
          title: this.$t('往来单位类型'),
          width: 150,
          dataIndex: 'payeeType',
          customRender: (text) => this.$store.getters.contactTypeMapping[text],
        },
        {
          title: this.$t('往来单位名称'),
          width: 150,
          dataIndex: 'payeeName',
        },
        {
          title: this.$t('结算组织'),
          width: 150,
          dataIndex: 'businessUnitName',
        },
        {
          title: this.$t('支付时间'),
          width: 200,
          dataIndex: 'payTime',
        },
        {
          title: this.$t('金额') + '(' + this.$t('未含税') + ')',
          width: 150,
          dataIndex: 'amountWithoutTax',
          scopedSlots: { customRender: 'amountWithoutTax' },
        },
        {
          title: this.$t('税额'),
          width: 150,
          dataIndex: 'taxAmount',
          scopedSlots: { customRender: 'taxAmount' },
        },
        {
          title: this.$t('价税合计'),
          width: 150,
          dataIndex: 'payableAmount',
          scopedSlots: { customRender: 'payableAmount' },
        },
        {
          title: this.$t('业务单号'),
          dataIndex: 'otherSns',
          width: 320,
          scopedSlots: { customRender: 'otherSns' },
        },
        {
          title: this.$t('源单类型'),
          dataIndex: 'sourceOrderType',
          width: 150,
          customRender: (text) => this.mappings.sourceOrderType[text] || text,
        },
        {
          title: this.$t('源单编码'),
          dataIndex: 'sourceOrderCode',
          width: 180,
          scopedSlots: { customRender: 'sourceOrderCode' },
        },
        {
          title: this.$t('能否生成凭证'),
          dataIndex: 'needGenerateVoucher',
          width: 150,
          customRender: (text, record) => {
            const val = record.needGenerateVoucher ?? record.need_generate_voucher
            return val === 1 ? this.$t('需要') : val === 0 ? this.$t('不需要') : ''
          },
        },
        {
          title: this.$t('是否生成凭证'),
          dataIndex: 'voucherGenerated',
          width: 150,
          customRender: (text) => (text ? this.$t('是') : this.$t('否')),
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucherNo',
          width: 180,
        },
        {
          title: this.$t('备注'),
          width: 120,
          dataIndex: 'remark',
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createdAt',
          width: 200,
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    async fetchMappings() {
      this.mappings = await fetchDocumentMappings(this.docType, ['orderType', 'sourceOrderType'])
    },
    reset() {
      Object.assign(this.$data, this.$options.data())
      this.searchHandle(1)
    },
    subtract,
    searchHandle(pageNo) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.waitInvoiceList = []
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    createHandle() {
      this.$router.push({
        name: 'depositPaymentDetail',
      })
    },
    viewDetail(record) {
      this.addPane({
        view: 'payableManage/depositPaymentDetail/' + record.orderSn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.orderSn,
        },
        route: `/payableManage/depositPaymentDetail?id=${record.id}&sn=${record.orderSn}`,
      })
    },
    chooseBizDate(date) {
      this.formData.bizDateStart = date.start_time
      this.formData.bizDateEnd = date.end_time
    },
    chooseArrivalStart(date) {
      this.formData.arrivalTimeStart = date.start_time
      this.formData.arrivalTimeEnd = date.end_time
    },
    async queryOrderList(params) {
      if (!this.formData.businessUnitCode) return
      let data = {
        ...this.formData,
        ...params,
      }
      let orderSn = spaceToComma(this.formData.orderSn)
      if (orderSn.includes(',')) {
        data.orderSnList = orderSn.split(',')
      } else if (orderSn) {
        data.orderSn = orderSn
      }
      this.tableLoading = true
      let res = await http({
        type: 'post',
        url: api.getDepositPaymentList,
        data,
      })
      let purchaseOrderList = [...(res.result.list || '')]
      this.tableData = convertKeysToCamelCase(purchaseOrderList)
      this.total = res.result.total
      this.tableLoading = false
      // 如果有待恢复的选中项，在列表加载完成后恢复
      if (this.pendingSelectedIds.length > 0) {
        this.$nextTick(() => {
          this.restoreSelection()
        })
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      let waitInvoiceList = selectedRows.filter((item) => item.invoiceStatus === 'WAIT_INVOICE')
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.waitInvoiceList = waitInvoiceList
    },
    copyOrderSn(text) {
      copy(text)
    },
    handleCheckSuccess() {
      // 如果当前状态是待审核，保存选中的订单ID
      const currentStatus = this.$refs.CommonTableRef?.status
      if (currentStatus === 'WAIT_CHECK') {
        this.pendingSelectedIds = [...this.selectedRowKeys]
        // 切换tab到待付款状态
        this.$refs.CommonTableRef.setSearchStatus('WAIT_PAY')
      } else {
        this.searchHandle()
      }
    },
    restoreSelection() {
      if (this.pendingSelectedIds.length === 0) return
      // 根据保存的ID重新选中
      const selectedKeys = []
      const selectedRows = []
      this.tableData.forEach((row) => {
        if (this.pendingSelectedIds.includes(row.id)) {
          selectedKeys.push(row.id)
          selectedRows.push(row)
        }
      })
      if (selectedKeys.length > 0) {
        // 通过 CommonTable 的 onSelectChange 方法来更新选中状态
        this.$refs.CommonTableRef.onSelectChange(selectedKeys, selectedRows)
      }
      this.pendingSelectedIds = []
    },
  },
}
</script>
